import { ThankYouCardApiClient } from '@fourthwall/services/dist/ThankYouCardApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useThankYouCardSettingsQuery = createQueryHook(ThankYouCardApiClient.getSettings, {
  queryKey: ['thankYouCardSettings'],
})
